import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'swisscom-sign-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private translate = inject(TranslateService);

  private readonly supportedLanguages = ['en', 'de', 'fr', 'it'];

  ngOnInit(): void {
    this.setLanguageFromOfficeContext();
  }

  private setLanguageFromOfficeContext(): void {
    let preferredLanguage = 'en'; // Fallback in English

    // Use Office API to get display language
    if (typeof Office !== 'undefined' && Office.context && Office.context.displayLanguage) {
      const languageCode = Office.context.displayLanguage.substring(0, 2);
      if (this.supportedLanguages.includes(languageCode)) {
        preferredLanguage = languageCode;
      }
    }

    //Set language in ngx-translate
    this.translate.addLangs(this.supportedLanguages);
    this.translate.setDefaultLang(preferredLanguage);
    this.translate.use(preferredLanguage);
  }
}
